<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="term.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <app-input
          label="Título"
          v-model="term.title"
          :errors="errors.title"
          required
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-field label="Texto" required>
          <editor
            v-model="term.text"
            :errors="errors.text"
            :api-key="tynemceApiKey"
            :init="tynemceConfig"
          />
        </b-field>
        <span class="error-alert" v-if="errors.text"
          >O campo de texto é obrigatório</span
        >
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button type="submit" :disabled='saving' v-app-button>Salvar</button>
      </div>
    </div>
  </form>
</template>

<script>
import TermOfAcceptanceService from '@/services/term-of-acceptance.service';

import ToastMixin from '@/mixins/ToastifyMixin';
import Editor from '@tinymce/tinymce-vue';

import { TYNEMCE } from '@/constants/tinymce.constants';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'term-of-acceptance-form',
  mixins: [ToastMixin],
  props: ['id', 'errors', 'saving'],
  components: { Editor },
  data: () => {
    return {
      tynemceApiKey: TYNEMCE.API_KEY,
      tynemceConfig: {
        height: 300,
        menubar: false,
        plugins: TYNEMCE.PLUGINS,
        toolbar: TYNEMCE.TOOLBAR,
      },
      loading: true,
      term: {
        active: true,
        title: null,
        text: null,
      },
      validations: {
        term: {
          title: { required },
          text: { required },
        },
      },
    };
  },
  methods: {
    loadTerm(id) {
      TermOfAcceptanceService.getId(id)
        .then(({ data }) => {
          this.term = data;
        })
        .catch(() => this.toastfy('Erro ao carregar termo.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', this.term);
    },
  },
  beforeMount() {
    if (this.id) this.loadTerm(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.error-alert {
  font-size: 0.8em;
  color: #ff6363;
  position: relative;
  top: -16px;
}
</style>
